<template>
    <div class="row align-items-center mb-4">
        <div class="col-lg-12">
            <div class="grey-box p-3 pt-4">
                <div class="row ">
                    <div class="col-md-6 text-left">
                        <h5 class="mt-1 mb-2 uk-text-bold">
                            <i class="fas fa-chart-bar mr-2"></i> List of Security Guards
                        </h5>
                    </div>
                    <div class="col-md-6 text-right">
                        <a @click="addGuard" class="save-btn sendmail-btn border-0 mt-2 mb-2 text-center">
                            <i class="fas fa-plus mr-2" style="font-size: 15px; display: block"></i> Add
                        </a>
                    </div>
                    <div class="col-lg-12">
                        <div class="table-responsive grey-box p-0">
                            <table class="table data-table table-round table-hover uk-animation-slide-bottom-small">
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">Gender, Age</th>
                                        <th scope="col">Location</th>
                                        <th scope="col">Service Area</th>
                                        <th scope="col">Working Days</th>
                                        <th scope="col">Status</th>
                                        <th scope="col" class="blankhead" width="150px"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(guard, gIndex1) in guardLists" >
                                        <template>
                                            <tr :key="gIndex1" ref="vehicleForm">
                                                <td>
                                                    <img :src="`/assets/img/logo.png`" class="uk-border-circle" width="55px" height="55px"> 
                                                </td>
                                                <td>
                                                    {{guard.gender}}, {{guard.dob|ages}}
                                                </td>
                                                <td>
                                                    {{guard.location}}
                                                </td>
                                                <td>
                                                    <span data-v-7b700eeb="" class="uk-label mr-1"> {{ guard.service_area }} </span>
                                                </td>
                                                <td>
                                                    {{ guard.working_days }} Days
                                                </td>
                                                <td class="text-center relative">
                                                    <label class="switch">
                                                        <input type="checkbox" v-model="guardLists[gIndex1].active" :checked="guard.active" />
                                                        <span class="slider round"></span>
                                                    </label>
                                                </td>
                                                
                                                <td class="text-right">
                                                    <a v-if="guard.id != undefined" data-toggle="collapse"
                                                        v-bind:data-target="`#profile_${guard.id}`"  
                                                        class="edit-btn clickable mb-2" 
                                                        type="button">
                                                        <i class="fal fa-edit"></i>
                                                    </a>

                                                    <button v-else type="button" @click="submitGuard(guard.id, gIndex1)" class="save-btn ml-2 mr-2" style="border:0px">
                                                        <i class="fas fa-save mr-2"></i> save
                                                    </button>
                                                    
                                                    <!-- <a v-if="guard.id != undefined" @click="copyVehicle(guard.id, gIndex1)" class="edit-btn mb-2" uk-toggle>
                                                        <i class="far fa-copy"></i>
                                                    </a> -->
                                                    <a @click="deleteGuard(guard.id, gIndex1)" href="#" class="del-btn mb-2">
                                                        <i class="fal fa-trash-alt"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                            <tr :key="'profile'+gIndex1" :id="`profile_${guard.id}`" class="collapse">
                                                <td colspan="7" class="p-3" style="border: 2px solid #dee2e6;border-radius: 10px;">
                                                    <div class="row">
                                                        <div class="col-md-12 mb-3">
                                                            <SecurityGuardForm />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                    <tr v-if="addNewGuard">
                                        <td colspan="7">
                                            <SecurityGuardForm />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- <div class="card-footer pb-0" v-show="vehicleList.length > 0">
                            <Pagination 
                            @getCurrentPagination="getCurrentPagination" 
                            :totalPages="paginData.totalPages"
                            :page="paginData.page" />
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SecurityGuardForm from "./SecurityGuardForm.vue"
export default {

    components: {
        SecurityGuardForm
    },
    mounted() {

        this.guardLists = [{ 
                id:1, 
                name: 'Mfd',
                gender: 'male',
                dob: '1991-11-10',
                location: 'Adress no.33',
                service_area: 'SG',
                working_days: 3,
                active: true,
                profile: '/assets/img/logo.png'
            }]

        // this.getGuardList()
    },
    data() {
        return {
            sortParams: {
                column: 'id',
                type: 'asc',
            },

            paginData: {
                page: 1,
                totalPages: 0,
                limit: this.$helpers.pageLimit()
            },

            filters: {
                keyword: '',
            },

            addNewGuard: false,

            guardLists: [],
        }
    },
    methods: {
    
        filter(keyword, type = 'keyword') {
            this.filters[type] = keyword
            this.getGuardList()
        },
        sort(params) {
            this.sortParams = {
                column: params.column,
                type: params.type,
            }
            this.getGuardList()
        },
        // getCurrentPagination(currentPage) {
        //     this.paginData.page = currentPage
        //     this.getGuardList()
        // },
        getGuardList() {
            axios.get('guards', {
                    params: {
                        page: this.paginData.page,
                        limit: this.paginData.limit,
                        sort_column: this.sortParams.column,
                        sort_type: this.sortParams.type,
                        keyword: this.filters.keyword,
                    }
                })
                .then((response) => {
                    if(response.data.success) {

                        this.guardLists = response.data.data
                        // this.paginData.totalPages = response.data.data.total_pages
                    }else{
                        this.$helpers.notification(response.data.success, response.data.message)
                    }
                })
                .catch((error) => {
                    this.$helpers.notification(response.data.success, error.message)
                    console.error('There was an error!', error)
                })
        },
        del_method: function (id, name) {
            UIkit.modal.confirm('Do you want to delete vihicle: ' + name + " ? ").then(
                function () {
                    axios.delete(`vehicles/${id}`)
                    .then(response => {
                        this.getGuardList()
                    })
                    .catch((error) => {
                        this.$helpers.notification(false, error.message)
                        console.error('There was an error!', error)
                    })
                },
            )
        },
        // vehicleActive(index) {
        //     this.guardLists[index].active = !this.guardLists[index].active
        //     console.log(this.guardLists[index].active)

        // },
        addGuard() {

            this.addNewGuard = true

            // this.guardLists.push({ 
            //     id:1, 
            //     name: 'Mfd',
            //     gender: 'male',
            //     location: 'Adress no.33',
            //     service_area: 'SG',
            //     working_days: 3,
            //     active: true,
            //     profile: '/assets/img/logo.png'
            // })
        },
        submitGuard(vehicleId, index) {
       
            if(this.guardLists[index].prices.length > 0) {
                this.updatePrice(vehicleId, index)
            }else{
                this.updateGuard(vehicleId, index)
            }
            
        },
        changeStatus(vehicleId, index) {
            this.updateGuard(vehicleId, index)
        },
        updateGuard(vehicleId, index) {
            const api = (vehicleId == undefined)? 'vehicles' :  'vehicles/' + vehicleId
            axios
                .post(api, this.getFormData(index), {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    console.log(response.data)
                    if(response.data.success) {
                        this.$helpers.notification(true, 'Success!')
                        this.getGuardList()
                    }else{
                        // this.requiredfileds = response.data
                    }
                })
                .catch((error) => {
                    this.$helpers.notification(false, error.message)

                    console.error('There was an error!', error.message)
                })
        },
        getFormData(index) {
            let formData = new FormData();

            let data = this.guardLists[index]
            formData.append('name_en', data.name_en)
            formData.append('vehicle_code', data.vehicle_code)
            formData.append('model', data.model)
            formData.append('brand', data.brand)
            formData.append('plate_number', data.plate_number)
            formData.append('total_seat', parseInt(data.total_seat))
            // formData.append('has_siren',false)
            // formData.append('is_police_vehicle', false)
            formData.append('active', data.active? 1 : 0)
            
            let images = this.guardLists[index].images
            if(images.length > 0){
                return this.getImg(images, formData)
            }
            
            return formData
        },
        getImg(images, formData) {

            let oldIds = []
            images.forEach(function(img){
                if(img.id){
                    oldIds.push(img.id)
                }
                if(img.file){
                    formData.append('images[]', img.file)
                }
            })
            
            if(oldIds.length > 0) {
                formData.append('old_images_id', oldIds.join(','))
            }
            return formData
        },
        deleteGuard(vehicleId, index) {

            if(vehicleId == undefined) {
                this.guardLists.splice(index, 1);
                this.$helpers.notification(true, 'Deleted!')
            }else{

                const api = 'vehicles/' + vehicleId
                axios
                    .delete(api)
                    .then((response) => {
                        if(response.data.success) {
                            this.$helpers.notification(false, 'Deleted!')
                            this.getGuardList()
                        }
                    })
                    .catch((error) => {
                        this.$helpers.notification(false, error.message)
                        console.error('There was an error!', error.message)
                    })
            }

        },
        addPrice(vehicleIndex) {
            console.log(this.guardLists[vehicleIndex.split('price')[1]].prices)
            this.guardLists[vehicleIndex.split('price')[1]].prices.push({})
        },
        updatePrice(vehicleId, vehicleIndex) {
                console.log(this.guardLists[vehicleIndex].prices)
                const api = `vehicles/${vehicleId}/prices`
                axios
                    .post(api, { prices: this.guardLists[vehicleIndex].prices })
                    .then((response) => {
                        
                        this.updateGuard(vehicleId, vehicleIndex)
                    })
                    .catch((error) => {
                        console.error('There was an error!', error.message)
                    })
        },
        deleteVPrice(priceIndex, vehicleIndex) {
            let vIndex = vehicleIndex.split('price')[1]
            let vehicle = this.guardLists[vIndex]
            let prices = this.guardLists[vIndex].prices
            let priceId = prices[priceIndex].id
                prices.splice(priceIndex, 1); 

            if( priceId != undefined){
                this.updatePrice(guard.id, vIndex)
            }
                this.$helpers.notification(false, 'Deleted!')

        },
        handleFileUpload(file, vIndex) {
            this.guardLists[vIndex].images.push({id:null, path:URL.createObjectURL(file[0]), file: file[0]})
        },
        deleteImage(vIndex, imgIndex) {
            this.guardLists[vIndex].images.splice(imgIndex, 1)
        }
    },
}
</script>
<style scoped>
</style>